import { createActor, canisterId } from "./declarations/backend"
import { queryReady } from "./query_ready.js"

const DASHBOARD = "https://ic-api.internetcomputer.org/api/v3"

// IC.time is nanoseconds since the Unix epoch.
export const formatSystemTime = (ns) =>
  new Date(Number(ns / 1_000_000n)).toISOString().replace("T", " ").replace(/\.\d+Z$/, " UTC")

// A canister cannot see its subnet's size, so ask the public IC dashboard:
// canister -> subnet -> total_nodes. Throws if either lookup fails (for
// example on a local network, which the dashboard has never heard of).
export const fetchNodeCount = async (id, fetchFn = fetch) => {
  const json = async (url) => {
    const res = await fetchFn(url)
    if (!res.ok) throw new Error(`${url}: ${res.status}`)
    return res.json()
  }
  const { subnet_id } = await json(`${DASHBOARD}/canisters/${id}`)
  const { total_nodes } = await json(`${DASHBOARD}/subnets/${subnet_id}`)
  return total_nodes
}

document.addEventListener("DOMContentLoaded", async () => {
  const timeEl = document.getElementById("system-time")
  const nodesEl = document.getElementById("node-count")
  if (!timeEl && !nodesEl) return

  const unavailable = "unavailable"
  if (!canisterId) {
    if (timeEl) timeEl.textContent = unavailable
    if (nodesEl) nodesEl.textContent = unavailable
    return
  }

  const stubbed = canisterId === "dev-stub"
  const stubNote = " (stubbed)"

  if (timeEl) {
    queryReady(createActor(canisterId)).then((actor) => actor.system_time())
      .then((ns) => { timeEl.textContent = formatSystemTime(ns) + (stubbed ? stubNote : "") })
      .catch((err) => { console.warn("system_time() failed", err); timeEl.textContent = unavailable })
  }

  if (nodesEl) {
    if (stubbed) {
      nodesEl.textContent = (process.env.STUB_NODE_COUNT || "13") + stubNote
    } else {
      fetchNodeCount(canisterId)
        .then((n) => { nodesEl.textContent = `${n}` })
        .catch((err) => { console.warn("node count lookup failed", err); nodesEl.textContent = unavailable })
    }
  }
})
